import {teemillDark} from './teemillDark';

export const teemillProDark = teemillDark
  .extend('teemillProDark')
  .property('primary.color', '#0aadff');
